module.exports = __webpack_public_path__ + "img/arrow-back.46a8695e.svg";